import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { TranslationHtmlWrapper } from "@ui/components/TranslationHtmlWrapper/TranslationHtmlWrapper";
import { useTranslations } from "@ui/providers/useTranslations";

import { useConfig } from "@jti/app-context/useConfig";
import { Checkbox } from "@jti/core-components/components/Checkbox";

import styles from "./PolicyCheckFields.module.scss";

type PolicyCheckFieldsProps = {
  showIsAdult?: boolean;
};

export const PolicyCheckFields: FC<PolicyCheckFieldsProps> = ({ showIsAdult }) => {
  const { __ } = useTranslations();
  const config = useConfig();
  const { control } = useFormContext();

  return (
    <div className={styles.container}>
      <Controller
        name="isPolicyRead"
        control={control}
        rules={{ required: __("form_validation.field_required") }}
        render={({ field: { value, onChange, ...fieldProps } }) => (
          <Checkbox
            {...fieldProps}
            id="is-policy-read"
            checked={Boolean(value)}
            onCheckedChange={onChange}
            label={
              <TranslationHtmlWrapper
                className={styles.isPolicyReadLink}
                text="policy_checks.policy_read"
                htmlData={[config.PRIVACY_PAGE_URL, config.TERMS_PAGE_URL]}
              />
            }
          />
        )}
      />
      {showIsAdult && (
        <Controller
          name="isAdult"
          control={control}
          rules={{ required: __("form_validation.field_required") }}
          render={({ field: { value, onChange, ...fieldProps } }) => (
            <Checkbox
              {...fieldProps}
              label={__("policy_checks.adult", [config.TERMS_ADULT_AGE, config.COUNTRY_NAME])}
              id="is-adult"
              checked={Boolean(value)}
              onCheckedChange={onChange}
            />
          )}
        />
      )}
    </div>
  );
};
